import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { NotaFiscalDevolucao } from "app/types/pesquisa-orcamento/consultas/Devolucoes";
import { Dict } from "app/utils/Dict";
import React from "react";
import { MenuSubConsultasDevolucoes } from "./MenuSubConsultasDevolucoes";
import { DevolucoesItensContainer } from "../devolucoes-orcamento/sub-consultas/itens/DevolucoesItensContainer";
import { DevolucoesFinanceiroContainer } from "../devolucoes-orcamento/sub-consultas/financeiro/DevolucoesFinanceiroContainer";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";


export type MenuSubConsultasDevolucoesContainerProps = {
    devolucaoSelecionada: Partial<NotaFiscalDevolucao>;
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onSelecionadoMenu: () => void;
    onVoltar: () => void;
    passos: Dict<string, () => void>;
}

export type MenuSubConsultasDevolucoes = {
    devolucaoSelecionada: Partial<NotaFiscalDevolucao>;
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover?: () => boolean;
}


export const MenuSubConsultasDevolucoesContainer = (props: MenuSubConsultasDevolucoesContainerProps) => {

    const propsBase: MenuSubConsultasDevolucoes = {
        devolucaoSelecionada: props.devolucaoSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onRemover: () => removerComponenteReact("pesquisar-pedidos-region"),
        onVoltar: () => props.onVoltar(),
        passos: props.passos,
    }


    const onRenderizarFinanceiro = () => {
        renderizarComponentReact(<DevolucoesFinanceiroContainer  {...propsBase} />, "pesquisar-pedidos-region", true)
    }

    const onRenderizarItens = () => {
        renderizarComponentReact(<DevolucoesItensContainer  {...propsBase} />, "pesquisar-pedidos-region", true)
    }


    return (
        <>

            <MenuSubConsultasDevolucoes
                onRenderizarFinanceiro={onRenderizarFinanceiro}
                onRenderizarItens={onRenderizarItens}
                onSelecionadoMenu={props.onSelecionadoMenu}
            />

        </>
    )
}